import React, { useContext, useEffect } from 'react';
import { BrowserRouter as AppRouter, Route, Switch, Redirect } from 'react-router-dom';
import NotFound from './NotFound';
import Unauthorized from '../shared/Unauthorized'
import AuthContext from '../context/auth'

// Routes
import { DefaultLayout, titleTemplate, defaultRoute, routes } from '../routes';

// ---
// Main route component

const Router = (props) => {
  // Set app loading class
  document.documentElement.classList.add('app-loading');

  const routesCleaned = routes.map((route) => {
    route.layout = route.layout || DefaultLayout;
    route.exact = typeof route.exact === 'undefined' ? true : route.exact;
    route.protected = typeof route.protected === 'undefined' ? false : route.protected;
    route.sidenavBack = typeof route.sidenavBack === 'undefined' ? false : route.sidenavBack;
    return route;
  });
  
  const { authenticated, subcribed } = useContext(AuthContext)

  const authorized = (authenticated && subcribed);

  useEffect(() => {
    const removeLoadingClass = () => {
      document.documentElement.classList.remove('app-loading');
    };

    // Remove splash screen
    const splashScreen = document.querySelector('.app-splash-screen');
    if (splashScreen) {
      splashScreen.style.opacity = 0;
      setTimeout(() => {
        splashScreen && splashScreen.parentNode.removeChild(splashScreen);
        removeLoadingClass();
      }, 300);
    } else {
      removeLoadingClass();
    }
  });

  const setTitle = (title) => {
    document.title = titleTemplate.replace('%s', title);
  }

  const scrollTop = (to, duration, element = document.scrollingElement || document.documentElement) => {
    if (element.scrollTop === to) return;
    const start = element.scrollTop;
    const change = to - start;
    const startDate = +new Date();

    if (!duration) {
      element.scrollTop = to;
      return;
    }

    // t = current time; b = start value; c = change in value; d = duration
    const easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };

    const animateScroll = () => {
      const currentDate = +new Date();
      const currentTime = currentDate - startDate;
      element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll);
      } else {
        element.scrollTop = to;
      }
    };

    animateScroll();
  }

  return (
    <AppRouter basename={process.env.REACT_APP_BASENAME}>
      <Switch>
            {routesCleaned.map((route) => (
              !authorized && route.protected ?
                <Route path={route.path} component={Unauthorized} key={route.path}/>
                :
                <Route
                  path={route.path}
                  exact={route.exact}
                  render={(props) => {
                    if (window.layoutHelpers && window.layoutHelpers.isSmallScreen()) {
                      window.layoutHelpers.setCollapsed(true, false);
                    }
                    scrollTop(0, 0);
                    return (
                      <route.layout {...props}>
                        <route.component {...props} setTitle={setTitle} scrollTop={scrollTop} sidenavBack={route.sidenavBack}/>
                      </route.layout>
                    );
                  }}
                  key={route.path}                  
                />
            ))}
            {defaultRoute !== '/' && <Redirect from='/' to={defaultRoute} exact={true}/>}
            <Route path='*' component={NotFound}/>
          </Switch>
    </AppRouter>
  );
}

export default Router;
